<div class="container">
  <div class="container py-5 ">
    <div class="container text-center">
      <p class=" fs-4 pt-2" style="color: var(--primary-color)">Más información al:</p>
    </div>
    <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
      <button class="buttonAction d-flex align-items-center justify-content-center">
        <img ngSrc="assets/img/ambulancia/icon%20correo.svg" alt="email" class=" flex-shrink-0" height="30" width="30">
        <span class="text-light px-2 fs-1"> <span class="fw-bold">comercial</span>&#64;medilink.com.ec</span>
      </button>
      <a href="https://wa.me/0984901595" target="_blank" class="buttonAction d-flex align-items-center justify-content-center">
        <img ngSrc="assets/img/movilink/whatsapLogo.svg" alt="whatsapLogo" class=" flex-shrink-0" height="30" width="30">
        <span class="text-light px-2 fs-1">098 490 1595</span>
      </a>
    </div>

  </div>
</div>

